/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ElectronBeamQualityDto } from './ElectronBeamQualityDto';
import {
    instanceOfElectronBeamQualityDto,
    ElectronBeamQualityDtoFromJSON,
    ElectronBeamQualityDtoFromJSONTyped,
    ElectronBeamQualityDtoToJSON,
} from './ElectronBeamQualityDto';
import type { PhotonBeamQualityDto } from './PhotonBeamQualityDto';
import {
    instanceOfPhotonBeamQualityDto,
    PhotonBeamQualityDtoFromJSON,
    PhotonBeamQualityDtoFromJSONTyped,
    PhotonBeamQualityDtoToJSON,
} from './PhotonBeamQualityDto';

/**
 * @type BeamQualityDto
 * 
 * @export
 */
export type BeamQualityDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.ElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared' } & ElectronBeamQualityDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.PhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared' } & PhotonBeamQualityDto;


export function BeamQualityDtoFromJSON(json: any): BeamQualityDto {
    return BeamQualityDtoFromJSONTyped(json, false);
}

export function BeamQualityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamQualityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.ElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...ElectronBeamQualityDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.ElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.PhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...PhotonBeamQualityDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.PhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of BeamQualityDto exists with '$type=${json['$type']}'`);
    }
}

export function BeamQualityDtoToJSON(value?: BeamQualityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.ElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return ElectronBeamQualityDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.PhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return PhotonBeamQualityDtoToJSON(value);
        default:
            throw new Error(`No variant of BeamQualityDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the BeamQualityDto interface.
 */
export function instanceOfBeamQualityDto(value: any): value is BeamQualityDto {
    if (instanceOfElectronBeamQualityDto(value)) return true;
    if (instanceOfPhotonBeamQualityDto(value)) return true;
    return false;
}

